/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AWSDate: { input: string; output: string; }
  AWSDateTime: { input: string; output: string; }
  AWSEmail: { input: any; output: any; }
  AWSIPAddress: { input: any; output: any; }
  AWSJSON: { input: any; output: any; }
  AWSPhone: { input: any; output: any; }
  AWSTime: { input: string; output: string; }
  AWSTimestamp: { input: any; output: any; }
  AWSURL: { input: any; output: any; }
  /**
   * POC ONLY. An MLC row verbatim, as the gateway returned it — an arbitrary JSON
   * object, not a shape. Exists so the POC can answer "does commerce already carry
   * this?" from real data instead of from the mapping below.
   */
  MlcRow: { input: Record<string, unknown>; output: Record<string, unknown>; }
};

export type AccessTarget = {
  __typename?: 'AccessTarget';
  label?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type Annotation = Bookmark | Highlight | Note | WorkbookResponse;

export type AnnotationProperties = {
  __typename?: 'AnnotationProperties';
  readerContentTitle?: Maybe<Scalars['String']['output']>;
  readerHint?: Maybe<Scalars['String']['output']>;
  readerHintFull?: Maybe<Scalars['String']['output']>;
  readerTocEntryTitle?: Maybe<Scalars['String']['output']>;
};

export type AnnotationPropertiesInput = {
  readerContentTitle: Scalars['String']['input'];
  readerHint: Scalars['String']['input'];
  readerHintFull: Scalars['String']['input'];
  readerTocEntryTitle: Scalars['String']['input'];
};

export enum AssetType {
  DigitalEvent = 'DIGITAL_EVENT',
  Ebook = 'EBOOK',
  Study = 'STUDY'
}

export type BibleBookSearchResult = {
  __typename?: 'BibleBookSearchResult';
  documents?: Maybe<Array<Maybe<SearchDocument>>>;
  name?: Maybe<Scalars['String']['output']>;
  numberFound?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['Int']['output']>;
};

export type BibleChapterAudio = {
  __typename?: 'BibleChapterAudio';
  audioUrl?: Maybe<Scalars['String']['output']>;
  verseTimes?: Maybe<Array<VerseTime>>;
};

export type BibleSearchResult = {
  __typename?: 'BibleSearchResult';
  books?: Maybe<Array<Maybe<BibleBookSearchResult>>>;
  contentId?: Maybe<Scalars['String']['output']>;
  totalFound?: Maybe<Scalars['Int']['output']>;
};

export type Bookmark = Node & {
  __typename?: 'Bookmark';
  asset?: Maybe<Scalars['String']['output']>;
  dateCreated?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModified?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  properties?: Maybe<AnnotationProperties>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type BookmarkRequest = {
  asset: Scalars['String']['input'];
  location: Scalars['String']['input'];
  properties: AnnotationPropertiesInput;
};

export type BreakoutSession = {
  __typename?: 'BreakoutSession';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  onDemandSources?: Maybe<OnDemandSources>;
  simulcastSources?: Maybe<SimulcastSources>;
  sources?: Maybe<Array<Maybe<Source>>>;
  speakers?: Maybe<Array<Speaker>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type BrightcoveIdentifiers = {
  __typename?: 'BrightcoveIdentifiers';
  accountId?: Maybe<Scalars['String']['output']>;
  videoCloudId?: Maybe<Scalars['String']['output']>;
};

export type Caption = {
  __typename?: 'Caption';
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type DailyReadingPlan = ReadingPlan & {
  __typename?: 'DailyReadingPlan';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  posterUrl?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  weekCount?: Maybe<Scalars['Int']['output']>;
  weeks?: Maybe<Array<DailyReadingPlanWeek>>;
};

export type DailyReadingPlanDay = {
  __typename?: 'DailyReadingPlanDay';
  dayNumber?: Maybe<Scalars['Int']['output']>;
  displayText?: Maybe<Scalars['String']['output']>;
  readings?: Maybe<Array<Reading>>;
};

export type DailyReadingPlanWeek = {
  __typename?: 'DailyReadingPlanWeek';
  days?: Maybe<Array<DailyReadingPlanDay>>;
  weekNumber?: Maybe<Scalars['Int']['output']>;
};

export type DigitalEvent = {
  days?: Maybe<Array<DigitalEventDay>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isStreaming?: Maybe<Scalars['Boolean']['output']>;
  managedSeriesId?: Maybe<Scalars['String']['output']>;
  ministryArea?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  posterUrl?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['AWSDateTime']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type DigitalEventDay = {
  __typename?: 'DigitalEventDay';
  breakoutSessions: Array<BreakoutSession>;
  date?: Maybe<Scalars['AWSDate']['output']>;
  onDemandSources?: Maybe<OnDemandSources>;
  sessions: Array<DigitalEventSession>;
  simulcastSources?: Maybe<SimulcastSources>;
  sources?: Maybe<Sources>;
};

export type DigitalEventEdge = {
  __typename?: 'DigitalEventEdge';
  addedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  cursor: Scalars['String']['output'];
  node: DigitalEvent;
};

export type DigitalEventFeedProgress = {
  __typename?: 'DigitalEventFeedProgress';
  complete: Scalars['Boolean']['output'];
  duration: Scalars['Int']['output'];
  farthestPosition: Scalars['Int']['output'];
  feed: Scalars['String']['output'];
  position: Scalars['Int']['output'];
};

export type DigitalEventProgress = {
  __typename?: 'DigitalEventProgress';
  complete: Scalars['Boolean']['output'];
  eventId: Scalars['String']['output'];
  progress: Scalars['Float']['output'];
  sessions: Array<DigitalEventSessionProgress>;
  userId: Scalars['String']['output'];
};

export type DigitalEventSession = {
  __typename?: 'DigitalEventSession';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  offsetDateTime?: Maybe<Scalars['AWSDateTime']['output']>;
  onDemandSources?: Maybe<OnDemandSources>;
  sessionStatus?: Maybe<SessionStatus>;
  simulcastSources?: Maybe<SimulcastSources>;
  sources?: Maybe<Sources>;
  speakers?: Maybe<Array<Speaker>>;
  time?: Maybe<Scalars['AWSTime']['output']>;
};

export enum DigitalEventSessionFeed {
  Asl = 'ASL',
  OpenCaptions = 'OPEN_CAPTIONS',
  Spanish = 'SPANISH',
  Standard = 'STANDARD'
}

export type DigitalEventSessionFeedProgress = {
  __typename?: 'DigitalEventSessionFeedProgress';
  complete?: Maybe<Scalars['Boolean']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  farthestPosition?: Maybe<Scalars['Int']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
};

export type DigitalEventSessionProgress = {
  __typename?: 'DigitalEventSessionProgress';
  complete: Scalars['Boolean']['output'];
  feedProgress: Array<DigitalEventFeedProgress>;
  sessionId: Scalars['String']['output'];
};

export type Ebook = Node & {
  __typename?: 'Ebook';
  cover?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lin?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type EbookEdge = Edge & {
  __typename?: 'EbookEdge';
  addedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  cursor: Scalars['String']['output'];
  node: Ebook;
};

export type EbookSearchResult = {
  __typename?: 'EbookSearchResult';
  contentId?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<Maybe<SearchDocument>>>;
  name?: Maybe<Scalars['String']['output']>;
  numberFound?: Maybe<Scalars['Int']['output']>;
};

export type Edge = {
  cursor: Scalars['String']['output'];
  node: Node;
};

export enum EngagementDomain {
  Account = 'ACCOUNT',
  Curriculum = 'CURRICULUM',
  CustomerLibrary = 'CUSTOMER_LIBRARY',
  DigitalEvent = 'DIGITAL_EVENT',
  Ebook = 'EBOOK',
  ReadingPlan = 'READING_PLAN',
  Study = 'STUDY',
  System = 'SYSTEM',
  Training = 'TRAINING',
  Video = 'VIDEO'
}

export type EngagementEventInput = {
  contentId?: InputMaybe<Scalars['ID']['input']>;
  context?: InputMaybe<Scalars['AWSJSON']['input']>;
  domain: EngagementDomain;
  event: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  timestampUtc: Scalars['AWSDateTime']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type Entitlement = Node & {
  __typename?: 'Entitlement';
  /** Lazy by design — one commerce call per row */
  accessTargets?: Maybe<Array<AccessTarget>>;
  /**
   * Where MLC's row-level Access button goes, when commerce hands it over without a
   * second call. Memberships carry it on the row; everything else needs
   * `accessTargets`, which is why that field is lazy.
   */
  accessUrl?: Maybe<Scalars['String']['output']>;
  category: EntitlementCategory;
  /**
   * POC ONLY — the upstream `/seats` or `/membership-items` row, unmapped and
   * unfiltered.
   *
   * Every other field on this type is a decision: MLC returns more than the
   * proposal models, and reading the mapper is not proof of what was dropped. This
   * carries the whole row alongside it so the field list can be argued from the
   * payload. It is scaffolding, not a proposal — a real schema models its fields
   * instead of tunnelling an upstream response through them.
   */
  data?: Maybe<Scalars['MlcRow']['output']>;
  /** MLC gates the OBS transfer case on these, and derives Ministry Grid membership from TMG/CLC */
  distributionChannelCodes?: Maybe<Array<Scalars['String']['output']>>;
  /** Licence-scoped. The same item can be seated twice under different licences, so the item number is NOT an identity */
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** MLC's 9-digit LIN — the join key to DCE assets, but not unique across seats */
  itemNumber: Scalars['String']['output'];
  /**
   * The licence the seat hangs off. Only MEMBERSHIP rows lack one.
   *
   * Present so per-row Manage Access can be built at all: FINDINGS.md gap 25 rules
   * it out against `libraryV2` because the DCE graph has no licence concept, and
   * every field it lists as missing is already on the `/seats` payload. This is the
   * shape proposal 02 would have to add.
   */
  license?: Maybe<EntitlementLicense>;
  /** Populated when DCE also serves this LIN as playable/readable content */
  linkedAsset?: Maybe<LibraryAsset>;
  /** Membership rows only — MLC's Memberships table shows Ordered On where the others show a view window */
  orderedOn?: Maybe<Scalars['AWSDateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** Seat startDate. Distinct from libraryV2's addedAt, which is projection-write time */
  viewOn?: Maybe<Scalars['AWSDateTime']['output']>;
  /** Seat endDate. Null means unbounded, NOT expired */
  viewUntil?: Maybe<Scalars['AWSDateTime']['output']>;
};

export enum EntitlementCategory {
  Application = 'APPLICATION',
  Download = 'DOWNLOAD',
  Ebook = 'EBOOK',
  Membership = 'MEMBERSHIP',
  Simulcast = 'SIMULCAST',
  /** Observed on UAT: a seat with no channel codes and no product metadata. MLC renders these in no section */
  Unknown = 'UNKNOWN',
  Video = 'VIDEO'
}

export type EntitlementEdge = Edge & {
  __typename?: 'EntitlementEdge';
  cursor: Scalars['String']['output'];
  node: Entitlement;
};

/**
 * The licence fields MLC's per-row Manage Access control reads
 * (`utils/media.js#isManageable`): manage rights, whether the licence has seats to
 * hand out, and whether an OBS seat is transferable.
 */
export type EntitlementLicense = {
  __typename?: 'EntitlementLicense';
  /** The path segment MLC deep-links to — /manage-access/{type}/{id} */
  id: Scalars['ID']['output'];
  isManager?: Maybe<Scalars['Boolean']['output']>;
  isOwner?: Maybe<Scalars['Boolean']['output']>;
  /** seats.isPermanent. A non-permanent OBS seat is transferable even at one seat */
  isPermanentSeat?: Maybe<Scalars['Boolean']['output']>;
  /** seats.count.total. A single-seat licence has nothing to manage */
  seatCount?: Maybe<Scalars['Int']['output']>;
};

export type Highlight = Node & {
  __typename?: 'Highlight';
  asset?: Maybe<Scalars['String']['output']>;
  color?: Maybe<HighlightColor>;
  dateCreated?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModified?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  properties?: Maybe<AnnotationProperties>;
  userId?: Maybe<Scalars['String']['output']>;
};

export enum HighlightColor {
  Blue = 'BLUE',
  Green = 'GREEN',
  Orange = 'ORANGE',
  Purple = 'PURPLE',
  Red = 'RED',
  Yellow = 'YELLOW'
}

export type HighlightRequest = {
  asset: Scalars['String']['input'];
  color: HighlightColor;
  location: Scalars['String']['input'];
  properties: AnnotationPropertiesInput;
};

export type IntercomAuthPayload = {
  __typename?: 'IntercomAuthPayload';
  token: Scalars['String']['output'];
};

export type LibraryAsset = Ebook | OnDemandEvent | SimulcastEvent | Study;

export type LibraryEdge = DigitalEventEdge | EbookEdge | StudyEdge;

export type LibraryItem = Node & {
  __typename?: 'LibraryItem';
  asset: LibraryAsset;
  contributors?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  lins?: Maybe<Array<Scalars['String']['output']>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type LibraryItemEdge = Edge & {
  __typename?: 'LibraryItemEdge';
  addedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  cursor: Scalars['String']['output'];
  node: LibraryItem;
};

export enum LibrarySortType {
  AddedAtAsc = 'ADDED_AT_ASC',
  AddedAtDesc = 'ADDED_AT_DESC',
  Relevance = 'RELEVANCE',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC'
}

export type LookupWordResponse = {
  __typename?: 'LookupWordResponse';
  cloud?: Maybe<Array<WordOccurance>>;
  key?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type LookupWordUsagesResponse = {
  __typename?: 'LookupWordUsagesResponse';
  books?: Maybe<Array<Scalars['String']['output']>>;
  groupedCitations?: Maybe<Array<WordUsageBook>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  createBookmark: Annotation;
  createHighlight: Annotation;
  createNote: Annotation;
  createStudy: Study;
  createWorkbookResponse: Annotation;
  deleteAnnotation: Scalars['ID']['output'];
  recordActivity: RecordActivityInputResponse;
  redeemCode: RedeemCodeResult;
  updateBookmark: Annotation;
  updateDigitalEventSessionFeedProgress: DigitalEventSessionFeedProgress;
  updateHighlight: Annotation;
  updateNote: Annotation;
  updateStudySessionVideoProgress: StudySessionVideoProgress;
  updateWorkbookResponse: Annotation;
};


export type MutationCreateBookmarkArgs = {
  annotation: BookmarkRequest;
};


export type MutationCreateHighlightArgs = {
  annotation: HighlightRequest;
};


export type MutationCreateNoteArgs = {
  annotation: NoteRequest;
};


export type MutationCreateStudyArgs = {
  slug: Scalars['String']['input'];
  studyId: Scalars['String']['input'];
  title: Scalars['String']['input'];
};


export type MutationCreateWorkbookResponseArgs = {
  annotation: WorkbookResponseRequest;
};


export type MutationDeleteAnnotationArgs = {
  annotationId: Scalars['String']['input'];
};


export type MutationRecordActivityArgs = {
  context?: InputMaybe<Scalars['AWSJSON']['input']>;
  events: Array<EngagementEventInput>;
};


export type MutationRedeemCodeArgs = {
  code: Scalars['String']['input'];
};


export type MutationUpdateBookmarkArgs = {
  annotation: BookmarkRequest;
  annotationId: Scalars['String']['input'];
};


export type MutationUpdateDigitalEventSessionFeedProgressArgs = {
  duration: Scalars['Int']['input'];
  eventId: Scalars['ID']['input'];
  feed: DigitalEventSessionFeed;
  position: Scalars['Int']['input'];
  sessionId: Scalars['ID']['input'];
};


export type MutationUpdateHighlightArgs = {
  annotation: HighlightRequest;
  annotationId: Scalars['String']['input'];
};


export type MutationUpdateNoteArgs = {
  annotation: NoteRequest;
  annotationId: Scalars['String']['input'];
};


export type MutationUpdateStudySessionVideoProgressArgs = {
  duration: Scalars['Int']['input'];
  position: Scalars['Int']['input'];
  sessionId: Scalars['String']['input'];
  studyId: Scalars['String']['input'];
};


export type MutationUpdateWorkbookResponseArgs = {
  annotation: WorkbookResponseRequest;
  annotationId: Scalars['String']['input'];
};

export type NoAccessError = {
  __typename?: 'NoAccessError';
  message?: Maybe<Scalars['String']['output']>;
};

export type Node = {
  id: Scalars['ID']['output'];
};

export type Note = Node & {
  __typename?: 'Note';
  asset?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  dateCreated?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModified?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  properties?: Maybe<AnnotationProperties>;
  title?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type NoteRequest = {
  asset: Scalars['String']['input'];
  content: Scalars['String']['input'];
  location: Scalars['String']['input'];
  properties: AnnotationPropertiesInput;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type OnDemandEvent = DigitalEvent & {
  __typename?: 'OnDemandEvent';
  days?: Maybe<Array<DigitalEventDay>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isStreaming?: Maybe<Scalars['Boolean']['output']>;
  lin?: Maybe<Scalars['String']['output']>;
  managedSeriesId?: Maybe<Scalars['String']['output']>;
  ministryArea?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  posterUrl?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['AWSDateTime']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type OnDemandSource = {
  __typename?: 'OnDemandSource';
  id: Scalars['ID']['output'];
  video?: Maybe<Video>;
  videoAvailabilityStatus?: Maybe<VideoAvailabilityStatus>;
  videoSources?: Maybe<VideoSourcesResponse>;
};

export type OnDemandSources = {
  __typename?: 'OnDemandSources';
  asl?: Maybe<OnDemandSource>;
  openCaptions?: Maybe<OnDemandSource>;
  spanish?: Maybe<OnDemandSource>;
  standard?: Maybe<OnDemandSource>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  bibleChapterAudioByID?: Maybe<BibleChapterAudio>;
  digitalEventByID?: Maybe<DigitalEvent>;
  intercomAuth?: Maybe<IntercomAuthPayload>;
  readingPlanById?: Maybe<ReadingPlan>;
  readingPlansConnection?: Maybe<ReadingPlanConnection>;
  searchBible?: Maybe<BibleSearchResult>;
  searchBibleBook?: Maybe<BibleBookSearchResult>;
  searchEbook?: Maybe<EbookSearchResult>;
  sessionByID?: Maybe<StudySession>;
  studyByID?: Maybe<Study>;
  user?: Maybe<User>;
  wordStudyLookupDictionaryEntry?: Maybe<Scalars['String']['output']>;
  wordStudyLookupUsages?: Maybe<LookupWordUsagesResponse>;
  wordStudyLookupWord?: Maybe<LookupWordResponse>;
};


export type QueryBibleChapterAudioByIdArgs = {
  audioTrackId: Scalars['String']['input'];
  book: Scalars['String']['input'];
  chapter: Scalars['Int']['input'];
  id: Scalars['String']['input'];
};


export type QueryDigitalEventByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryReadingPlanByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryReadingPlansConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySearchBibleArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  ebookId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


export type QuerySearchBibleBookArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  book: Scalars['String']['input'];
  ebookId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


export type QuerySearchEbookArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  ebookId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


export type QuerySessionByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryStudyByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryWordStudyLookupDictionaryEntryArgs = {
  ebookId: Scalars['String']['input'];
  word: Scalars['String']['input'];
};


export type QueryWordStudyLookupUsagesArgs = {
  ebookId: Scalars['String']['input'];
  word: Scalars['String']['input'];
};


export type QueryWordStudyLookupWordArgs = {
  ebookId: Scalars['String']['input'];
  word: Scalars['String']['input'];
};

export type Reading = ScriptureReading;

export type ReadingPlan = {
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  posterUrl?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  weekCount?: Maybe<Scalars['Int']['output']>;
};

export type ReadingPlanConnection = {
  __typename?: 'ReadingPlanConnection';
  edges: Array<ReadingPlanEdge>;
  pageInfo: PageInfo;
};

export type ReadingPlanEdge = {
  __typename?: 'ReadingPlanEdge';
  cursor: Scalars['String']['output'];
  node: ReadingPlan;
};

export type RecordActivityInputResponse = {
  __typename?: 'RecordActivityInputResponse';
  eventId?: Maybe<Scalars['String']['output']>;
};

export type RedeemCodeFailure = {
  __typename?: 'RedeemCodeFailure';
  /** ALREADY_REDEEMED carries what the customer already owns */
  existingItems?: Maybe<Array<Entitlement>>;
  message?: Maybe<Scalars['String']['output']>;
  reason: RedeemCodeFailureReason;
};

export enum RedeemCodeFailureReason {
  AlreadyRedeemed = 'ALREADY_REDEEMED',
  CtgUsed = 'CTG_USED',
  Expired = 'EXPIRED',
  Invalid = 'INVALID',
  LimitExceeded = 'LIMIT_EXCEEDED',
  NotYetActive = 'NOT_YET_ACTIVE',
  Unknown = 'UNKNOWN'
}

export type RedeemCodeResult = RedeemCodeFailure | RedeemCodeSuccess;

export type RedeemCodeSuccess = {
  __typename?: 'RedeemCodeSuccess';
  code: Scalars['String']['output'];
  /** From the commerce response, so the confirmation never waits on the projection */
  grantedItems: Array<Entitlement>;
};

export type ScriptureReading = {
  __typename?: 'ScriptureReading';
  label?: Maybe<Scalars['String']['output']>;
  sfi?: Maybe<Scalars['String']['output']>;
};

export type SearchDocument = {
  __typename?: 'SearchDocument';
  fileContent?: Maybe<Scalars['String']['output']>;
  filePath?: Maybe<Scalars['String']['output']>;
  header?: Maybe<Scalars['String']['output']>;
  hlCFIRange?: Maybe<Scalars['String']['output']>;
  tocSequence?: Maybe<Scalars['String']['output']>;
};

export type SearchSuggestion = {
  __typename?: 'SearchSuggestion';
  highlightedTerm?: Maybe<Scalars['String']['output']>;
  term?: Maybe<Scalars['String']['output']>;
};

export type SessionSource = OnDemandSource | SimulcastSource;

export enum SessionStatus {
  ActiveSimulcast = 'ACTIVE_SIMULCAST',
  AvailableOnDemand = 'AVAILABLE_ON_DEMAND',
  PreSimulcast = 'PRE_SIMULCAST',
  Processing = 'PROCESSING'
}

export type SimulcastEvent = DigitalEvent & {
  __typename?: 'SimulcastEvent';
  days?: Maybe<Array<DigitalEventDay>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isStreaming?: Maybe<Scalars['Boolean']['output']>;
  lin?: Maybe<Scalars['String']['output']>;
  managedSeriesId?: Maybe<Scalars['String']['output']>;
  ministryArea?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  posterUrl?: Maybe<Scalars['String']['output']>;
  simulcastStatus?: Maybe<SimulcastStatus>;
  startDate?: Maybe<Scalars['AWSDateTime']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type SimulcastSource = {
  __typename?: 'SimulcastSource';
  backupUrl?: Maybe<Scalars['String']['output']>;
  hlsUrl?: Maybe<Scalars['String']['output']>;
  primaryUrl: Scalars['String']['output'];
};

export type SimulcastSources = {
  __typename?: 'SimulcastSources';
  asl?: Maybe<SimulcastSource>;
  openCaptions?: Maybe<SimulcastSource>;
  spanish?: Maybe<SimulcastSource>;
  standard?: Maybe<SimulcastSource>;
};

export enum SimulcastStatus {
  Idle = 'IDLE',
  LiveHostcastTesting = 'LIVE_HOSTCAST_TESTING',
  LiveTesting = 'LIVE_TESTING',
  Streaming = 'STREAMING'
}

export type Source = {
  __typename?: 'Source';
  hlsUrl: Scalars['String']['output'];
};

export type Sources = {
  __typename?: 'Sources';
  asl?: Maybe<SessionSource>;
  standard?: Maybe<SessionSource>;
};

export type Speaker = {
  __typename?: 'Speaker';
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

export type Study = Node & {
  __typename?: 'Study';
  authors?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  images?: Maybe<StudyImages>;
  lin?: Maybe<Scalars['String']['output']>;
  ministryArea?: Maybe<Scalars['String']['output']>;
  productionYear?: Maybe<Scalars['Int']['output']>;
  sessions?: Maybe<Array<StudySession>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type StudyEdge = Edge & {
  __typename?: 'StudyEdge';
  addedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  cursor: Scalars['String']['output'];
  node: Study;
};

export type StudyImages = {
  __typename?: 'StudyImages';
  posterUrl?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

export type StudyProgress = {
  __typename?: 'StudyProgress';
  complete: Scalars['Boolean']['output'];
  progress: Scalars['Float']['output'];
  sessions: Array<StudySessionProgress>;
  studyId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type StudySession = VideoSession;

export type StudySessionProgress = {
  __typename?: 'StudySessionProgress';
  sessionId: Scalars['String']['output'];
  videoProgress: StudySessionVideoProgress;
};

export type StudySessionVideoProgress = {
  __typename?: 'StudySessionVideoProgress';
  complete?: Maybe<Scalars['Boolean']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  farthestPosition?: Maybe<Scalars['Int']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
};

export type TextTracks = {
  __typename?: 'TextTracks';
  captions?: Maybe<Array<Maybe<Caption>>>;
};

export type User = {
  __typename?: 'User';
  annotationsForEbook?: Maybe<Array<Annotation>>;
  digitalEventProgress?: Maybe<DigitalEventProgress>;
  digitalEventsConnection?: Maybe<UserDigitalEventsConnection>;
  ebookById?: Maybe<UserEbook>;
  ebooksConnection?: Maybe<UserEbookConnection>;
  entitlements?: Maybe<UserEntitlementConnection>;
  library?: Maybe<UserLibraryConnection>;
  librarySearchSuggestions?: Maybe<Array<SearchSuggestion>>;
  libraryV2?: Maybe<UserLibraryConnectionV2>;
  studiesConnection?: Maybe<UserStudiesConnection>;
  studyProgress?: Maybe<StudyProgress>;
};


export type UserAnnotationsForEbookArgs = {
  ebookId: Scalars['ID']['input'];
};


export type UserDigitalEventProgressArgs = {
  eventId: Scalars['String']['input'];
};


export type UserDigitalEventsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type UserEbookByIdArgs = {
  id: Scalars['ID']['input'];
};


export type UserEbooksConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type UserEntitlementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<EntitlementCategory>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<LibrarySortType>;
};


export type UserLibraryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assetTypes: Array<AssetType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<LibrarySortType>;
};


export type UserLibrarySearchSuggestionsArgs = {
  assetTypes: Array<AssetType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type UserLibraryV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  assetTypes: Array<AssetType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<LibrarySortType>;
};


export type UserStudiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type UserStudyProgressArgs = {
  studyId: Scalars['String']['input'];
};

export type UserDigitalEventsConnection = {
  __typename?: 'UserDigitalEventsConnection';
  edges: Array<DigitalEventEdge>;
  pageInfo: PageInfo;
};

export type UserEbook = {
  __typename?: 'UserEbook';
  ebook?: Maybe<Ebook>;
  hasAccess?: Maybe<Scalars['Boolean']['output']>;
};

export type UserEbookConnection = {
  __typename?: 'UserEbookConnection';
  edges: Array<EbookEdge>;
  pageInfo: PageInfo;
};

export type UserEntitlementConnection = {
  __typename?: 'UserEntitlementConnection';
  edges: Array<EntitlementEdge>;
  pageInfo: PageInfo;
};

export type UserLibraryConnection = {
  __typename?: 'UserLibraryConnection';
  edges: Array<LibraryEdge>;
  pageInfo: PageInfo;
};

export type UserLibraryConnectionV2 = {
  __typename?: 'UserLibraryConnectionV2';
  edges: Array<LibraryItemEdge>;
  pageInfo: PageInfo;
};

export type UserStudiesConnection = {
  __typename?: 'UserStudiesConnection';
  edges: Array<StudyEdge>;
  pageInfo: PageInfo;
};

export type VendorIdentifiers = {
  __typename?: 'VendorIdentifiers';
  brightcove?: Maybe<BrightcoveIdentifiers>;
};

export type VerseTime = {
  __typename?: 'VerseTime';
  book: Scalars['String']['output'];
  chapter: Scalars['Int']['output'];
  end: Scalars['Float']['output'];
  sfi: Scalars['String']['output'];
  start: Scalars['Float']['output'];
  verse: Scalars['Int']['output'];
};

export type Video = {
  __typename?: 'Video';
  description?: Maybe<Scalars['String']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  productionYear?: Maybe<Scalars['Int']['output']>;
  progress?: Maybe<VideoProgress>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  vendorIdentifiers?: Maybe<VendorIdentifiers>;
  videoSources?: Maybe<VideoSourcesResponse>;
};

export enum VideoAvailabilityStatus {
  Available = 'AVAILABLE',
  Processing = 'PROCESSING'
}

export type VideoProgress = {
  __typename?: 'VideoProgress';
  lastUpdate: Scalars['AWSDateTime']['output'];
  playheadSeconds: Scalars['Int']['output'];
};

export type VideoSession = {
  __typename?: 'VideoSession';
  description?: Maybe<Scalars['String']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  productionYear?: Maybe<Scalars['Int']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  vendorIdentifiers?: Maybe<VendorIdentifiers>;
  video?: Maybe<Video>;
  videoSources?: Maybe<VideoSourcesResponse>;
};

export type VideoSources = {
  __typename?: 'VideoSources';
  dash?: Maybe<Scalars['String']['output']>;
  durationMilliseconds?: Maybe<Scalars['Int']['output']>;
  hls?: Maybe<Scalars['String']['output']>;
  mp4?: Maybe<Scalars['String']['output']>;
  textTracks?: Maybe<TextTracks>;
  thumbnailsUrl?: Maybe<Scalars['String']['output']>;
};

export type VideoSourcesResponse = NoAccessError | VideoSources;

export type WordCitation = {
  __typename?: 'WordCitation';
  fragment?: Maybe<Scalars['String']['output']>;
  scripture?: Maybe<Scalars['String']['output']>;
  target?: Maybe<Scalars['String']['output']>;
};

export type WordOccurance = {
  __typename?: 'WordOccurance';
  citations?: Maybe<Array<WordCitation>>;
  count?: Maybe<Scalars['Int']['output']>;
  occurrence?: Maybe<Scalars['String']['output']>;
};

export type WordUsageBook = {
  __typename?: 'WordUsageBook';
  book?: Maybe<Scalars['String']['output']>;
  citations?: Maybe<Array<WordUsageCitation>>;
};

export type WordUsageCitation = {
  __typename?: 'WordUsageCitation';
  fragment?: Maybe<WordUsageFragment>;
  hit?: Maybe<Scalars['String']['output']>;
  phrase?: Maybe<Scalars['String']['output']>;
  scripture?: Maybe<Scalars['String']['output']>;
  strongs?: Maybe<Scalars['String']['output']>;
  verseFragment?: Maybe<Scalars['String']['output']>;
};

export type WordUsageFragment = {
  __typename?: 'WordUsageFragment';
  text?: Maybe<Scalars['String']['output']>;
};

export type WorkbookResponse = Node & {
  __typename?: 'WorkbookResponse';
  asset?: Maybe<Scalars['String']['output']>;
  dateCreated?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModified?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  properties?: Maybe<AnnotationProperties>;
  response?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type WorkbookResponseRequest = {
  asset: Scalars['String']['input'];
  location: Scalars['String']['input'];
  properties: AnnotationPropertiesInput;
  response: Scalars['String']['input'];
};

export type GetEbookAccessQueryVariables = Exact<{
  ebookId: Scalars['ID']['input'];
}>;


export type GetEbookAccessQuery = { __typename?: 'Query', user?: { __typename?: 'User', ebookById?: { __typename?: 'UserEbook', hasAccess?: boolean | null } | null } | null };

export type EntitlementRowFragment = { __typename?: 'Entitlement', id: string, itemNumber: string, title?: string | null, category: EntitlementCategory, viewOn?: string | null, viewUntil?: string | null, orderedOn?: string | null, imageUrl?: string | null, accessUrl?: string | null, distributionChannelCodes?: Array<string> | null, data?: Record<string, unknown> | null, license?: { __typename?: 'EntitlementLicense', id: string, isOwner?: boolean | null, isManager?: boolean | null, seatCount?: number | null, isPermanentSeat?: boolean | null } | null };

export type GetEntitlementsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetEntitlementsQuery = { __typename?: 'Query', user?: { __typename?: 'User', entitlements?: { __typename?: 'UserEntitlementConnection', edges: Array<{ __typename?: 'EntitlementEdge', cursor: string, node: { __typename?: 'Entitlement', id: string, itemNumber: string, title?: string | null, category: EntitlementCategory, viewOn?: string | null, viewUntil?: string | null, orderedOn?: string | null, imageUrl?: string | null, accessUrl?: string | null, distributionChannelCodes?: Array<string> | null, data?: Record<string, unknown> | null, license?: { __typename?: 'EntitlementLicense', id: string, isOwner?: boolean | null, isManager?: boolean | null, seatCount?: number | null, isPermanentSeat?: boolean | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null } | null };

export type RedeemCodeMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type RedeemCodeMutation = { __typename?: 'Mutation', redeemCode: { __typename: 'RedeemCodeFailure', reason: RedeemCodeFailureReason, message?: string | null, existingItems?: Array<{ __typename?: 'Entitlement', id: string, itemNumber: string, title?: string | null, category: EntitlementCategory, viewOn?: string | null, viewUntil?: string | null, orderedOn?: string | null, imageUrl?: string | null, accessUrl?: string | null, distributionChannelCodes?: Array<string> | null, data?: Record<string, unknown> | null, license?: { __typename?: 'EntitlementLicense', id: string, isOwner?: boolean | null, isManager?: boolean | null, seatCount?: number | null, isPermanentSeat?: boolean | null } | null }> | null } | { __typename: 'RedeemCodeSuccess', code: string, grantedItems: Array<{ __typename?: 'Entitlement', id: string, itemNumber: string, title?: string | null, category: EntitlementCategory, viewOn?: string | null, viewUntil?: string | null, orderedOn?: string | null, imageUrl?: string | null, accessUrl?: string | null, distributionChannelCodes?: Array<string> | null, data?: Record<string, unknown> | null, license?: { __typename?: 'EntitlementLicense', id: string, isOwner?: boolean | null, isManager?: boolean | null, seatCount?: number | null, isPermanentSeat?: boolean | null } | null }> } };

export type EventSessionSourceFragment = { __typename?: 'OnDemandSource', id: string, video?: { __typename?: 'Video', id: string, title?: string | null, description?: string | null, thumbnailUrl?: string | null, progress?: { __typename?: 'VideoProgress', lastUpdate: string, playheadSeconds: number } | null, vendorIdentifiers?: { __typename?: 'VendorIdentifiers', brightcove?: { __typename?: 'BrightcoveIdentifiers', accountId?: string | null, videoCloudId?: string | null } | null } | null, videoSources?: { __typename: 'NoAccessError', message?: string | null } | { __typename: 'VideoSources', durationMilliseconds?: number | null, thumbnailsUrl?: string | null } | null } | null };

export type GetDigitalEventByIdQueryVariables = Exact<{
  eventId: Scalars['String']['input'];
}>;


export type GetDigitalEventByIdQuery = { __typename?: 'Query', digitalEventByID?: { __typename: 'OnDemandEvent', id: string, name?: string | null, description?: string | null, startDate?: string | null, ministryArea?: string | null, thumbnailUrl?: string | null, posterUrl?: string | null, days?: Array<{ __typename?: 'DigitalEventDay', date?: string | null, sessions: Array<{ __typename?: 'DigitalEventSession', id: string, name?: string | null, description?: string | null, time?: string | null, sessionStatus?: SessionStatus | null, speakers?: Array<{ __typename?: 'Speaker', id: string, firstName?: string | null, lastName?: string | null }> | null, onDemandSources?: { __typename?: 'OnDemandSources', standard?: { __typename?: 'OnDemandSource', id: string, video?: { __typename?: 'Video', id: string, title?: string | null, description?: string | null, thumbnailUrl?: string | null, progress?: { __typename?: 'VideoProgress', lastUpdate: string, playheadSeconds: number } | null, vendorIdentifiers?: { __typename?: 'VendorIdentifiers', brightcove?: { __typename?: 'BrightcoveIdentifiers', accountId?: string | null, videoCloudId?: string | null } | null } | null, videoSources?: { __typename: 'NoAccessError', message?: string | null } | { __typename: 'VideoSources', durationMilliseconds?: number | null, thumbnailsUrl?: string | null } | null } | null } | null } | null }> }> | null } | { __typename: 'SimulcastEvent', id: string, isStreaming?: boolean | null, name?: string | null, description?: string | null, startDate?: string | null, ministryArea?: string | null, thumbnailUrl?: string | null, posterUrl?: string | null, days?: Array<{ __typename?: 'DigitalEventDay', date?: string | null, sessions: Array<{ __typename?: 'DigitalEventSession', id: string, name?: string | null, description?: string | null, time?: string | null, sessionStatus?: SessionStatus | null, speakers?: Array<{ __typename?: 'Speaker', id: string, firstName?: string | null, lastName?: string | null }> | null, onDemandSources?: { __typename?: 'OnDemandSources', standard?: { __typename?: 'OnDemandSource', id: string, video?: { __typename?: 'Video', id: string, title?: string | null, description?: string | null, thumbnailUrl?: string | null, progress?: { __typename?: 'VideoProgress', lastUpdate: string, playheadSeconds: number } | null, vendorIdentifiers?: { __typename?: 'VendorIdentifiers', brightcove?: { __typename?: 'BrightcoveIdentifiers', accountId?: string | null, videoCloudId?: string | null } | null } | null, videoSources?: { __typename: 'NoAccessError', message?: string | null } | { __typename: 'VideoSources', durationMilliseconds?: number | null, thumbnailsUrl?: string | null } | null } | null } | null } | null }> }> | null } | null };

export type LibraryPageInfoFragment = { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null };

export type GetStudyLibraryQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<LibrarySortType>;
}>;


export type GetStudyLibraryQuery = { __typename?: 'Query', user?: { __typename?: 'User', libraryV2?: { __typename?: 'UserLibraryConnectionV2', edges: Array<{ __typename?: 'LibraryItemEdge', cursor: string, addedAt?: string | null, node: { __typename?: 'LibraryItem', id: string, asset: { __typename: 'Ebook', id: string } | { __typename: 'OnDemandEvent', id: string } | { __typename: 'SimulcastEvent', id: string } | { __typename: 'Study', id: string, title?: string | null, description?: string | null, authors?: Array<string> | null, ministryArea?: string | null, productionYear?: number | null, images?: { __typename?: 'StudyImages', thumbnailUrl?: string | null, posterUrl?: string | null } | null } } }>, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null } | null };

export type GetEbookLibraryQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<LibrarySortType>;
}>;


export type GetEbookLibraryQuery = { __typename?: 'Query', user?: { __typename?: 'User', libraryV2?: { __typename?: 'UserLibraryConnectionV2', edges: Array<{ __typename?: 'LibraryItemEdge', cursor: string, addedAt?: string | null, node: { __typename?: 'LibraryItem', id: string, asset: { __typename: 'Ebook', id: string, title?: string | null, cover?: string | null } | { __typename: 'OnDemandEvent', id: string } | { __typename: 'SimulcastEvent', id: string } | { __typename: 'Study', id: string } } }>, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null } | null };

export type GetDigitalEventLibraryQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<LibrarySortType>;
}>;


export type GetDigitalEventLibraryQuery = { __typename?: 'Query', user?: { __typename?: 'User', libraryV2?: { __typename?: 'UserLibraryConnectionV2', edges: Array<{ __typename?: 'LibraryItemEdge', cursor: string, addedAt?: string | null, node: { __typename?: 'LibraryItem', id: string, asset: { __typename: 'Ebook', id: string } | { __typename: 'OnDemandEvent', id: string, name?: string | null, description?: string | null, startDate?: string | null, thumbnailUrl?: string | null, posterUrl?: string | null, ministryArea?: string | null, timezone?: string | null } | { __typename: 'SimulcastEvent', id: string, name?: string | null, description?: string | null, startDate?: string | null, thumbnailUrl?: string | null, posterUrl?: string | null, isStreaming?: boolean | null, ministryArea?: string | null, timezone?: string | null } | { __typename: 'Study', id: string } } }>, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null } | null };

export type GetStudyByIdQueryVariables = Exact<{
  studyId: Scalars['String']['input'];
}>;


export type GetStudyByIdQuery = { __typename?: 'Query', studyByID?: { __typename?: 'Study', id: string, title?: string | null, description?: string | null, authors?: Array<string> | null, ministryArea?: string | null, productionYear?: number | null, images?: { __typename?: 'StudyImages', posterUrl?: string | null, thumbnailUrl?: string | null } | null, sessions?: Array<{ __typename: 'VideoSession', id: string, video?: { __typename?: 'Video', id: string, title?: string | null, description?: string | null, thumbnailUrl?: string | null, progress?: { __typename?: 'VideoProgress', lastUpdate: string, playheadSeconds: number } | null, vendorIdentifiers?: { __typename?: 'VendorIdentifiers', brightcove?: { __typename?: 'BrightcoveIdentifiers', accountId?: string | null, videoCloudId?: string | null } | null } | null, videoSources?: { __typename: 'NoAccessError', message?: string | null } | { __typename: 'VideoSources', durationMilliseconds?: number | null, thumbnailsUrl?: string | null } | null } | null }> | null } | null };

export const EntitlementRowFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntitlementRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entitlement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"itemNumber"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"viewOn"}},{"kind":"Field","name":{"kind":"Name","value":"viewUntil"}},{"kind":"Field","name":{"kind":"Name","value":"orderedOn"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"accessUrl"}},{"kind":"Field","name":{"kind":"Name","value":"distributionChannelCodes"}},{"kind":"Field","name":{"kind":"Name","value":"license"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isOwner"}},{"kind":"Field","name":{"kind":"Name","value":"isManager"}},{"kind":"Field","name":{"kind":"Name","value":"seatCount"}},{"kind":"Field","name":{"kind":"Name","value":"isPermanentSeat"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}}]} as unknown as DocumentNode<EntitlementRowFragment, unknown>;
export const EventSessionSourceFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventSessionSource"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OnDemandSource"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"progress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastUpdate"}},{"kind":"Field","name":{"kind":"Name","value":"playheadSeconds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorIdentifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brightcove"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"videoCloudId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoSources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoSources"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"durationMilliseconds"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NoAccessError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EventSessionSourceFragment, unknown>;
export const LibraryPageInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LibraryPageInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PageInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]} as unknown as DocumentNode<LibraryPageInfoFragment, unknown>;
export const GetEbookAccessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEbookAccess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ebookId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ebookById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ebookId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasAccess"}}]}}]}}]}}]} as unknown as DocumentNode<GetEbookAccessQuery, GetEbookAccessQueryVariables>;
export const GetEntitlementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEntitlements"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entitlements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntitlementRow"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntitlementRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entitlement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"itemNumber"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"viewOn"}},{"kind":"Field","name":{"kind":"Name","value":"viewUntil"}},{"kind":"Field","name":{"kind":"Name","value":"orderedOn"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"accessUrl"}},{"kind":"Field","name":{"kind":"Name","value":"distributionChannelCodes"}},{"kind":"Field","name":{"kind":"Name","value":"license"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isOwner"}},{"kind":"Field","name":{"kind":"Name","value":"isManager"}},{"kind":"Field","name":{"kind":"Name","value":"seatCount"}},{"kind":"Field","name":{"kind":"Name","value":"isPermanentSeat"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}}]} as unknown as DocumentNode<GetEntitlementsQuery, GetEntitlementsQueryVariables>;
export const RedeemCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RedeemCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"redeemCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RedeemCodeSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"grantedItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntitlementRow"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RedeemCodeFailure"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"existingItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntitlementRow"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntitlementRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entitlement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"itemNumber"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"viewOn"}},{"kind":"Field","name":{"kind":"Name","value":"viewUntil"}},{"kind":"Field","name":{"kind":"Name","value":"orderedOn"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"accessUrl"}},{"kind":"Field","name":{"kind":"Name","value":"distributionChannelCodes"}},{"kind":"Field","name":{"kind":"Name","value":"license"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isOwner"}},{"kind":"Field","name":{"kind":"Name","value":"isManager"}},{"kind":"Field","name":{"kind":"Name","value":"seatCount"}},{"kind":"Field","name":{"kind":"Name","value":"isPermanentSeat"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}}]} as unknown as DocumentNode<RedeemCodeMutation, RedeemCodeMutationVariables>;
export const GetDigitalEventByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDigitalEventById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"digitalEventByID"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"ministryArea"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"posterUrl"}},{"kind":"Field","name":{"kind":"Name","value":"days"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"sessions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"sessionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"speakers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"onDemandSources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"standard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventSessionSource"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimulcastEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isStreaming"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OnDemandEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventSessionSource"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OnDemandSource"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"progress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastUpdate"}},{"kind":"Field","name":{"kind":"Name","value":"playheadSeconds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorIdentifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brightcove"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"videoCloudId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoSources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoSources"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"durationMilliseconds"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NoAccessError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetDigitalEventByIdQuery, GetDigitalEventByIdQueryVariables>;
export const GetStudyLibraryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStudyLibrary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LibrarySortType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"libraryV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetTypes"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"STUDY"}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"addedAt"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Study"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"authors"}},{"kind":"Field","name":{"kind":"Name","value":"ministryArea"}},{"kind":"Field","name":{"kind":"Name","value":"productionYear"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"posterUrl"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Ebook"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimulcastEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OnDemandEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LibraryPageInfo"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LibraryPageInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PageInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]} as unknown as DocumentNode<GetStudyLibraryQuery, GetStudyLibraryQueryVariables>;
export const GetEbookLibraryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEbookLibrary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LibrarySortType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"libraryV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetTypes"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"EBOOK"}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"addedAt"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Ebook"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"cover"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Study"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimulcastEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OnDemandEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LibraryPageInfo"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LibraryPageInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PageInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]} as unknown as DocumentNode<GetEbookLibraryQuery, GetEbookLibraryQueryVariables>;
export const GetDigitalEventLibraryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDigitalEventLibrary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LibrarySortType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"libraryV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetTypes"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"DIGITAL_EVENT"}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"addedAt"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimulcastEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"posterUrl"}},{"kind":"Field","name":{"kind":"Name","value":"isStreaming"}},{"kind":"Field","name":{"kind":"Name","value":"ministryArea"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OnDemandEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"posterUrl"}},{"kind":"Field","name":{"kind":"Name","value":"ministryArea"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Study"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Ebook"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LibraryPageInfo"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LibraryPageInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PageInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]} as unknown as DocumentNode<GetDigitalEventLibraryQuery, GetDigitalEventLibraryQueryVariables>;
export const GetStudyByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStudyById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"studyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"studyByID"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"studyId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"authors"}},{"kind":"Field","name":{"kind":"Name","value":"ministryArea"}},{"kind":"Field","name":{"kind":"Name","value":"productionYear"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"posterUrl"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sessions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoSession"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"progress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastUpdate"}},{"kind":"Field","name":{"kind":"Name","value":"playheadSeconds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorIdentifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brightcove"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"videoCloudId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoSources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoSources"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"durationMilliseconds"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NoAccessError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetStudyByIdQuery, GetStudyByIdQueryVariables>;